import { FC, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { books } from "@/assets/books";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { RequireAuth } from "@/components/RequireAuth";
import ForgotPassword from "@/components/UI/modal/Wallet/ForgotPassword";
import DeactivateAccountModal from "../component/DeactivateAccountModal";
import SettingsUserIconSvg from "@/assets/svg/SettingsUserIconSvg";
import SettingsLockSvg from "@/assets/svg/SettingsLockSvg";
import BasketSvg from "@/assets/svg/BasketSvg";
import { useAppSelector } from "@/hooks/useAppSelector";
import MenuItemCard from "../component/MenuItemCard";
import CustomToast from "@/components/UI/CustomToast/CustomToast";

const YourAccount: FC = () => {
  const [isDeactivateOpen, setIsDeactivateOpen] = useState(false);
  const [walletForgotPasswordModalOpen, setWalletForgotPasswordModalOpen] = useState(false);
  const [toast, setToast] = useState<{ message: string; success: boolean } | null>(null);
  const location = useLocation();

  useEffect(() => {
    if (location.state?.message) {
      setToast({
        message: location.state.message,
        success: location.state.success ?? true,
      });

      window.history.replaceState({}, document.title);
    }
  }, [location.state]);
  const [menuItems] = useState([
    {
      title: "Account information",
      subtitle: "See your account information like your phone number and email address",
      icon: <SettingsUserIconSvg height={24} width={24} />,
      show: false,
      link: books.confirmPassword,
    },
    {
      title: "Change your password",
      subtitle: "Change your password at any time",
      icon: <SettingsLockSvg height={24} width={24} />,
      show: false,
      link: books.settingsChangePassword,
    },
    {
      title: "Deactivate your account",
      subtitle: "",
      icon: <BasketSvg variant="filled" />,
      // isDeactivate: true,
      link: books.deactivateYourAccount,
    },
  ]);

  const isRootSettings = location.pathname === "/settings/account";
  const { user } = useAppSelector((state) => state.auth);
  const shouldBlock = !user && location.pathname.startsWith("/settings/account");

  return (
    <Box
      sx={{
        display: "flex",
        gap: "12px",
        width: "100%",
      }}
    >
      {isRootSettings ? (
        <Box>
          {toast && (
            <CustomToast
              message={toast.message}
              success={toast.success}
              onClose={() => setToast(null)}
            />
          )}
          <DeactivateAccountModal
            open={isDeactivateOpen}
            onClose={() => setIsDeactivateOpen(false)}
            onConfirm={() => {
              setIsDeactivateOpen(false);
            }}
          />
          {walletForgotPasswordModalOpen && (
            <ForgotPassword onClose={() => setWalletForgotPasswordModalOpen(false)} />
          )}

          <Box
            sx={{
              height: "54px",
              padding: "15px 0 15px 16px",
            }}
          >
            <Typography
              sx={{
                fontFamily: "Inter",
                fontWeight: 600,
                fontStyle: "Semi Bold",
                fontSize: "18px",
                lineHeight: "24px",
                letterSpacing: "0px",
              }}
            >
              Your Account
            </Typography>
          </Box>
          <Box bgcolor="white">
            <RequireAuth>
              {menuItems.map((item, index) => (
                <MenuItemCard key={index} item={item} />
              ))}
            </RequireAuth>
          </Box>
        </Box>
      ) : shouldBlock ? (
        <Navigate to="/settings" replace />
      ) : (
        <Box sx={{ maxWidth: "544px", width: "100%" }}>
          <Outlet />
        </Box>
      )}
    </Box>
  );
};

export default YourAccount;
